import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { NormalizedUIField } from '../../../store/config.models';

@Component({
    selector: 'app-icon-element',
    templateUrl: './icon-element.component.html',
    styleUrls: ['./icon-element.component.scss'],
})
export class IconElementComponent {
    @Input() field: NormalizedUIField;
    @Input() isReadOnly = false;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    /**
     * Handles icon click actions by dispatching any configured events
     */
    onIconAction(event: Event): void {
        if (this.isReadOnly || this.field.disabled) {
            return;
        }

        if (this.field.events?.onClick) {
            this.field.events.onClick(event).forEach((action) => this.store.dispatch(action));
        }
    }
}
